// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__7wc9N","title":"Images45_title__s_pg0","images":"Images45_images__2r7cb"};